import { DialogPanelComponentContent } from './../../models/dialogs/DialogPanelComponentContent';
import { Component, ElementRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'tip',
    templateUrl: './tip.component.html',
})
export class TipComponent extends DialogPanelComponentContent {

    public image: string;
    public title: string;
    constructor(
        public elementRef: ElementRef,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<TipComponent>,
    ) {
        super(elementRef, true);
        this.image = data.image;
        this.title = data.title;
    }

    public closeTip() {
        super.close(this.dialogRef, true);
    }

}
